import React from "react";
import { Modal, ModalBody } from "reactstrap";

interface DeleteItemModalProps {
  show?: boolean;
  onDeleteClick?: () => void;
  onCloseClick?: () => void;
  title?: string;
  description?: string;
  icon?: any;
  confirmText?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

const DeleteItemModal: React.FC<DeleteItemModalProps> = ({
  show,
  onDeleteClick,
  onCloseClick,
  title = "Are you sure ?",
  description = "Are you sure you want to remove this record?",
  icon,
  confirmText = "Yes, Delete It!",
  disabled = false,
  isLoading = false
}) => {
  return (
    <Modal
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
      contentClassName="br-7"
    >
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          {icon ? (
            icon
          ) : (
            <i className="ri-delete-bin-line display-5 text-danger"></i>
          )}
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>{title}</h4>
            <p className="text-muted mx-4 mb-0">{description}</p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Close
          </button>
          <button
            type="button"
            className={`btn w-sm ${icon ? "btn-primary" : "btn-danger "}`}
            id="delete-record"
            onClick={onDeleteClick}
            disabled={disabled}
          >
            {isLoading ? (
              <span className="spinner-border spinner-border-sm align-middle" role="status" aria-hidden="true"></span>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeleteItemModal;
